import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import {useTitle} from 'react-use';
import usePreferences from "../hooks/usePreferences.ts";
import {Trans} from "@lingui/react/macro";
import {t} from "@lingui/core/macro";
import {LocaleSelect} from "../share";

export const locales = {
    
    "en": "English",
    "hr": "Hrvatski",
}

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: (theme.vars ?? theme).palette.text.secondary,
    ...theme.applyStyles('dark', {
        backgroundColor: '#1A2027',
    }),
}));

const PreferencesPage = () => {

    useTitle(t`Preferences`);

    const {themeMode, prefsChangeThemeMode} = usePreferences()

    return (
        <Paper sx={ {padding: "2em"} }>
            <Container
                sx={ {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                } }
            >
                <Stack direction="column" spacing={3}>
                    <Typography
                        textAlign='center'
                        component='h2'
                        variant='h2'
                        divider={<Divider orientation="horizontal" flexItem />}
                    >
                        <Trans>Preferences</Trans>
                    </Typography>


                    <Box
                        sx={ {
                            display: 'flex',
                            width: '100%',
                            alignItems: 'center',
                            justifyContent: 'center',
                            bgcolor: 'background.default',
                            color: 'text.primary',
                            borderRadius: 1,
                            p: 3,
                            minHeight: '56px',
                        } }
                    >
                        <FormControl>
                            <Stack spacing={2}>
                                <Item>
                                    <FormLabel id="demo-theme-toggle"><Trans>Theme</Trans></FormLabel>
                                    <RadioGroup
                                        aria-labelledby="demo-theme-toggle"
                                        name="theme-toggle"
                                        row
                                        value={themeMode}
                                        onChange={(event) =>
                                            prefsChangeThemeMode(event.target.value as 'system' | 'light' | 'dark')
                                        }
                                    >
                                        <FormControlLabel value="system" control={<Radio/>} label={t`System`}/>
                                        <FormControlLabel value="light" control={<Radio/>} label={t`Light`}/>
                                        <FormControlLabel value="dark" control={<Radio/>} label={t`Dark`}/>
                                    </RadioGroup>
                                </Item>
                                <Item>
                                    <LocaleSelect locales={locales}/>
                                </Item>
                            </Stack>
                        </FormControl>
                    </Box>
                </Stack>
            </Container>
        </Paper>
    );
};

export default PreferencesPage;
